import React from 'react'
import {useTranslation} from 'react-i18next'
import './index.scss'

export default function Empty({ ...props }) {
  const {t} = useTranslation()
  return (
    <div className="empty">
      <div className="empty__body">
        <img src="/img/Empty.png" alt="empty home" />
        <p>{t('access_denied')}</p>
      </div>
    </div>
  )
}
